import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import { deleteExpense } from '#/graphql/mutations';
import { GET_WORK_ORDER_RELATED_COUNTS } from '#/modules/workOrder/hooks/useWorkOrderRelatedCountsQuery';

const q = gql(deleteExpense);

const useExpenseDelete = () => {
  const [mutation, result] = useMutation(q);

  const deleteExpense = useCallback(
    (expenseId: string, workOrderId?: string) => {
      const refetchQueries: {
        query: typeof GET_WORK_ORDER_RELATED_COUNTS;
        variables?: { workOrderId: string };
      }[] = [];

      if (workOrderId) {
        refetchQueries.push({ query: GET_WORK_ORDER_RELATED_COUNTS, variables: { workOrderId } });
      }

      return mutation({
        variables: {
          id: expenseId,
        },
        refetchQueries,
        awaitRefetchQueries: true,
      });
    },
    [mutation],
  );

  return { deleteExpense, result };
};

export default useExpenseDelete;
